module.exports = __webpack_public_path__ + "img/600a.32f72264.png";